import { cn } from '@/lib/utils';

const TONES = {
  neutral: 'bg-slate-100 text-slate-700',
  primary: 'bg-blue-50 text-blue-800',
  success: 'bg-emerald-50 text-emerald-800',
  warning: 'bg-amber-50 text-amber-800',
  danger: 'bg-rose-50 text-rose-800',
  live: 'bg-emerald-500 text-white',
};

export default function ResqlyStatus({ children, tone = 'neutral', dot = false, className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold tracking-wide',
        TONES[tone] || TONES.neutral,
        className,
      )}
    >
      {dot && (
        <span
          className={cn(
            'h-1.5 w-1.5 rounded-full',
            tone === 'live' ? 'bg-white animate-pulse' : 'bg-current opacity-70',
          )}
        />
      )}
      {children}
    </span>
  );
}
